<div class="toolbar-container" cdkDrag [cdkDragBoundary]="dragBoundary" [ngStyle]="position">
  <div cdkDragHandle class="drag-handler cursor-move">
    <fa-icon [icon]="['fal', 'grip-horizontal']"></fa-icon>
  </div>
  <div class="toolbar-content">
    <ng-content></ng-content>
  </div>
</div>
